import { Routes, Route } from "react-router-dom";
import AppShell from "@/components/AppShell";

import Dashboard from "@/pages/admin/Dashboard";
import Organizations from "@/pages/admin/Organizations";
import Vendors from "@/pages/admin/Vendors";
import Distributors from "@/pages/admin/Distributors";
import TenantActivity from "@/pages/admin/TenantActivity";
import Subscriptions from "@/pages/admin/Subscriptions";
import PlatformUsers from "@/pages/admin/PlatformUsers";
import PlatformRoles from "@/pages/admin/PlatformRoles";
import Marketplace from "@/pages/admin/Marketplace";
import ProductMasters from "@/pages/admin/ProductMasters";
import AICenter from "@/pages/admin/AICenter";
import Payments from "@/pages/admin/Payments";
import Support from "@/pages/admin/Support";
import Monitoring from "@/pages/admin/Monitoring";
import Security from "@/pages/admin/Security";
import Notifications from "@/pages/admin/Notifications";
import Reports from "@/pages/admin/Reports";
import CMS from "@/pages/admin/CMS";
import Integrations from "@/pages/admin/Integrations";
import GlobalSettings from "@/pages/admin/GlobalSettings";
import PlatformPlans from "@/pages/admin/PlatformPlans";
import PlatformTrials from "@/pages/admin/PlatformTrials";
import PlatformRoleEngine from "@/pages/admin/PlatformRoleEngine";
import PlatformPricingConfig from "@/pages/admin/PlatformPricingConfig";
import PlatformLeads from "@/pages/admin/PlatformLeads";
import PlatformSubscriptions from "@/pages/admin/PlatformSubscriptions";
import PlatformHierarchy from "@/pages/admin/PlatformHierarchy";
import PaymentGatewayConfig from "@/pages/admin/PaymentGatewayConfig";
import PendingRegistrations from "@/pages/admin/PendingRegistrations";
import EmailSettings from "@/pages/admin/EmailSettings";
import EmailConnections from "@/pages/admin/EmailConnections";
import AuditLog from "@/pages/settings/AuditLog";
import MfaSettings from "@/pages/settings/Mfa";

export default function SuperAdminDashboard() {
  return (
    <AppShell variant="admin">
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/tenants" element={<Organizations />} />
        <Route path="/organizations" element={<Organizations />} />
        <Route path="/vendors" element={<Vendors />} />
        <Route path="/distributors" element={<Distributors />} />
        <Route path="/tenants/:tenantId/activity" element={<TenantActivity />} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        <Route path="/users" element={<PlatformUsers />} />
        <Route path="/roles" element={<PlatformRoles />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/product-masters" element={<ProductMasters />} />
        <Route path="/ai" element={<AICenter />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/support" element={<Support />} />
        <Route path="/monitoring" element={<Monitoring />} />
        <Route path="/security" element={<Security />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/cms" element={<CMS />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/settings" element={<GlobalSettings />} />
        <Route path="/platform/plans" element={<PlatformPlans />} />
        <Route path="/platform/trials" element={<PlatformTrials />} />
        <Route path="/platform/roles" element={<PlatformRoleEngine />} />
        <Route path="/platform/hierarchy" element={<PlatformHierarchy />} />
        <Route path="/platform/pricing" element={<PlatformPricingConfig />} />
        <Route path="/platform/leads" element={<PlatformLeads />} />
        <Route path="/platform/subscriptions" element={<PlatformSubscriptions />} />
        <Route path="/platform/payment-gateway" element={<PaymentGatewayConfig />} />
        <Route path="/platform/registrations" element={<PendingRegistrations />} />
        <Route path="/platform/email-settings" element={<EmailSettings />} />
        <Route path="/platform/email-connections" element={<EmailConnections />} />
        <Route path="/audit" element={<AuditLog />} />
        <Route path="/settings/mfa" element={<MfaSettings />} />
      </Routes>
    </AppShell>
  );
}
